import { composeStore } from 'owa-mail-compose-store';

export default function getCurrentDeepLinkRoute() {
    const route: string[] = ['deeplink'];

    if (composeStore.primaryComposeId) {
        route.push('compose');

        const composeViewState = composeStore.viewStates.get(composeStore.primaryComposeId);

        if (composeViewState.itemId?.Id) {
            route.push(composeViewState.itemId.Id);
        }
    }

    return route;
}
